import { useCallback, useEffect, useMemo, useState } from 'react'
import { useAppSelector } from '../redux/hook';

export default function useRetrieveMyInfoStageB(retrieveCallBack:()=>void, removeCallBack:()=>void, original_uinfin:string, alwaysShow:boolean = true, isDeclaration:boolean = false) {

  const retrieveMyInfoByNRIC = useAppSelector(state => state.auth.AuthenticationSlice.retrieveFromMyInfo);
  const retrieveMyInfoDeclaration = useAppSelector(state => state.auth.AuthenticationSlice.retrieveFromMyInfoDeclaration);
  const loginUser = useAppSelector(state => state.auth.AuthenticationSlice.loginUser);

  const [ isRetrieve, setRetrieve ] = useState<boolean>(false);
  const [ isMyInfoLoading, setMyInfoLoading ] = useState<boolean>(false);
  const [ init, setInit ] = useState<boolean>(true);


 
  const toShowMyInfo = useMemo(() => {
    if(alwaysShow){
      return alwaysShow;
    }
    else{
      return original_uinfin === loginUser.uinfin;
    }
  }, [alwaysShow, loginUser.uinfin, original_uinfin])


  useEffect(() => {
    let timeout_id:number;
    timeout_id = window.setTimeout(()=>{
      if((!isDeclaration && retrieveMyInfoByNRIC) || (isDeclaration && retrieveMyInfoDeclaration)){
        setMyInfoLoading(true);
        setRetrieve(true);
        if(init && retrieveCallBack && loginUser.uinfin === original_uinfin){
          retrieveCallBack();
          setInit(false);
        }
        setTimeout(()=>{
          setMyInfoLoading(false);
        },1000);
      }
    },500);
    return () =>{
      clearTimeout(timeout_id);
    }
  }, [ original_uinfin ]);

  const toggleRetrieveMyInfo = useCallback(()=>{
    setMyInfoLoading(true);
    let timeout_id:number;

    timeout_id = window.setTimeout(()=>{
      if(!isRetrieve){
        if(retrieveCallBack){
          retrieveCallBack();
          setRetrieve(true);
        }
      }else if(removeCallBack){
        removeCallBack();
        setRetrieve(false);
      }
    },200);

    return () =>{
      clearTimeout(timeout_id);
    }
  },[isRetrieve, removeCallBack, retrieveCallBack]);
  

  const myInfoLoadingValue = useCallback((value:boolean)=>{
    setMyInfoLoading(value);
  },[])
  

  return { isRetrieve, isMyInfoLoading, toShowMyInfo, toggleRetrieveMyInfo, myInfoLoadingValue, setRetrieve }
}
